/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/global/Fandango.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'Fandango', exports: {} }; const exports = module.exports;

Fandango.pageDetails = Fandango.pageDetails || {};
Fandango.templates = Fandango.templates || {};
export default Fandango;